import React from 'react'

import { Pluralize } from '@sketch/components'
import { formatByteCount } from '@sketch/utils'
import { DownloadableAssetRenderedNotificationFragment } from '@sketch/gql-types'

import { AssetIconBox, DownloadIcon } from './DownloadableAssetPreview.styles'
import {
  Card,
  Separator,
  Thumbnail,
  Tile,
  TileMeta,
  TileTitle,
  TileWrapper,
} from './TileCard.styles'

interface DownloadableAssetPreviewProps {
  notification: DownloadableAssetRenderedNotificationFragment
}

export const DownloadableAssetPreview = ({
  notification,
}: DownloadableAssetPreviewProps) => {
  const { share, workspace } = notification
  const asset = notification.notifiedVersion?.document?.downloadableAssets[0]

  if (!asset || !share) return null

  const assetCount = asset.layerUuids.length
  const size =
    asset.fileSizeInBytes != null
      ? formatByteCount(asset.fileSizeInBytes)
      : null

  return (
    <Card>
      <TileWrapper>
        <Tile>
          <AssetIconBox aria-hidden>
            <DownloadIcon />
          </AssetIconBox>
          <Pluralize
            singular="asset"
            count={assetCount}
            showCount
            wrapperElement={TileTitle}
          />
          {size && <TileMeta>{size}</TileMeta>}
          <TileMeta>ZIP</TileMeta>
        </Tile>

        <Separator />

        <Tile>
          <Thumbnail aria-hidden />
          <TileTitle>{share.name}</TileTitle>
          {share.project?.name && <TileMeta>{share.project.name}</TileMeta>}
          {workspace?.name && <TileMeta>{workspace.name}</TileMeta>}
        </Tile>
      </TileWrapper>
    </Card>
  )
}
